export class SIQBannerColorTheme {
  backgroundColor = "null";
  textColor = "null";
}
//# sourceMappingURL=SIQBannerColorTheme.js.map